
    <div id="toasty" [ngClass]="[position]">
        <ng2-toast *ngFor="let toast of toasts" [toast]="toast" (closeToast)="closeToast(toast)"></ng2-toast>
    </div>